// extracted by mini-css-extract-plugin
export default {"container":"Quote_container__wr51Q","Main":"Quote_Main__3RCV+","Source":"Quote_Source__6-anv"};